import {layoutModuleMap} from './constants';

// 重复的公共配置项前置
const sizeControlParams = {
    typeOptions: [
        {
            value: 'choose',
            label: '选择尺寸'
        }, {
            value: 'custom',
            label: '自定义尺寸'
        }
    ],
    options: [
        {
            value: '1:1',
            label: '比例1:1',
            children: [
                {
                    value: '240*240',
                    label: '尺寸240*240'
                }, {
                    value: '120*120',
                    label: '尺寸120*120'
                }, {
                    value: '80*80',
                    label: '尺寸80*80'
                }, {
                    value: '220*220',
                    label: '尺寸220*220'
                }, {
                    value: '250*250',
                    label: '尺寸250*250'
                }, {
                    value: '60*60',
                    label: '尺寸60*60'
                }, {
                    value: '360*360',
                    label: '尺寸360*360'
                }, {
                    value: '480*480',
                    label: '尺寸480*480'
                }, {
                    value: '600*600',
                    label: '尺寸600*600'
                }, {
                    value: '300*300',
                    label: '尺寸300*300'
                }
            ]
        }, {
            value: '2:1',
            label: '比例2:1',
            children: [
                {
                    value: '800*400',
                    label: '尺寸800*400'
                }, {
                    value: '600*300',
                    label: '尺寸600*300'
                }
            ]
        }, {
            value: '3:2',
            label: '比例3:2',
            children: [
                {
                    value: '370*245',
                    label: '尺寸370*245'
                }, {
                    value: '960*640',
                    label: '尺寸960*640'
                }, {
                    value: '378*252',
                    label: '尺寸378*252'
                }, {
                    value: '1200*800',
                    label: '尺寸1200*800'
                }, {
                    value: '900*600',
                    label: '尺寸900*600'
                }, {
                    value: '300*200',
                    label: '尺寸300*200'
                }
            ]
        }, {
            value: '2:3',
            label: '比例2:3',
            children: [
                {
                    value: '1080*1620',
                    label: '尺寸1080*1620'
                }, {
                    value: '1242*1863',
                    label: '尺寸1242*1863'
                }
            ]
        }, {
            value: '3:1',
            label: '比例3:1',
            children: [
                {
                    value: '1200*400',
                    label: '尺寸1200*400'
                }, {
                    value: '1152*384',
                    label: '尺寸1152*384'
                }, {
                    value: '900*300',
                    label: '尺寸900*300'
                }
            ]
        }, {
            value: '4:3',
            label: '比例4:3',
            children: [
                {
                    value: '800*600',
                    label: '尺寸800*600'
                }, {
                    value: '120*90',
                    label: '尺寸120*90'
                }
            ]
        }, {
            value: '9:16',
            label: '比例9:16',
            children: [
                {
                    value: '1080*1920',
                    label: '尺寸1080*1920'
                }, {
                    value: '1242*2208',
                    label: '尺寸1242*2208'
                }, {
                    value: '720*1280',
                    label: '尺寸720*1280'
                }
            ]
        }, {
            value: '16:9',
            label: '比例16:9',
            children: [
                {
                    value: '1140*640',
                    label: '尺寸1140*640'
                }, {
                    value: '1280*720',
                    label: '尺寸1280*720'
                }, {
                    value: '1600*900',
                    label: '尺寸1600*900'
                }, {
                    value: '1920*1080',
                    label: '尺寸1920*1080'
                }, {
                    value: '960*540',
                    label: '尺寸960*540'
                }
            ]
        }
    ]
};

// 尺寸的规则
const sizeControlRules = [
    {
        required: true,
        validator(rule, value) {
            const {type, value: val} = value;
            if (type === 'custom' && (!val.customWidth || !val.customHeight)) {
                return Promise.reject('请输入自定义尺寸');
            }
            return Promise.resolve();
          }
    }
];

export const formConfig = [
    {
        name: 'stitchLayout',
        label: '布局模板',
        placeholder: '',
        visible: true,
        type: 'stitchLayout',
        params: {
            typeOptions: [
                {
                    label: 2,
                    value: 2
                },
                {
                    label: 3,
                    value: 3
                },
                {
                    label: 4,
                    value: 4
                },
                {
                    label: 5,
                    value: 5
                },
                {
                    label: 6,
                    value: 6
                },
                {
                    label: 7,
                    value: 7
                },
                {
                    label: 8,
                    value: 8
                },
                {
                    label: 9,
                    value: 9
                }
            ],
            optionsMap: layoutModuleMap
        }
    },
    {
        name: 'sizeControl',
        label: '请选择拼图尺寸',
        placeholder: '',
        visible: true,
        type: 'sizeControl',
        params: sizeControlParams,
        rules: sizeControlRules
    },
    {
        name: 'stitchTargetCount',
        label: '拼图数量',
        placeholder: '',
        visible: true,
        type: 'stitchTargetCount',
        params: {
            limit: 2,
            typeOptions: [
                {
                    label: '1张',
                    value: '1'
                },
                {
                    label: '2张',
                    value: '2'
                },
                {
                    label: '3张',
                    value: '3'
                }
            ]
        },
        rules: [
            {
                required: true,
                validator(rule, data) {
                    const {value} = data;
                    if (value.uploadList?.length !== value.totalNum) {
                        return Promise.reject('图片数量不足');
                    }
                    return Promise.resolve();
                  }
            }
        ]
    },
    {
        name: 'stitchSpace',
        label: '间距',
        placeholder: '',
        visible: true,
        type: 'stitchSpace'
    }
];

